import events from '@layers/web/constants/events.ts'

export default defineNuxtPlugin((nuxtApp) => {
  const {
    ENABLE_TRACKING,
    GTM_URI,
    ADTRACTION_URI,
  } = nuxtApp.$config.public

  window.addEventListener(
    events.rbcsChange,
    () => {
      const scripts: Array<Record<string, string | boolean>> = []

      if (ENABLE_TRACKING && GTM_URI) {
        scripts.push({
          key: 'gtm',
          src: GTM_URI,
          defer: true,
          fetchpriority: 'low',
        })
      }

      if (ENABLE_TRACKING && ADTRACTION_URI) {
        scripts.push({
          key: 'adtraction',
          src: ADTRACTION_URI,
          defer: true,
          fetchpriority: 'low',
        })
      }

      if (scripts.length) {
        useHead({ script: scripts })
      }
    }
  )
})